var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.loader)?_c('app-loader'):_vm._e(),_c('div',{attrs:{"id":"textEditor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }